<template lang="pug">
.cell(:style="{'left': (100 * (node.offset - papa.offset) / papa.width)+'%', width: (100 * node.width / papa.width)+'%'}" @mouseover.stop="selected = true" @mouseout.stop="selected = false" @click.stop="handleClick")
  .node-title(:style="{'background-color': currentColor, 'color': textColor}" :class="{'only-partial': node.only, 'has-info-link': node.level === 0 && node.href}")
    .text(:class="{'vertical': !node.hasChildren || node.isLeaf || node.level >= 3}") {{node.title}}
      a.info-btn(v-if="node.level === 0 && node.href" :href="node.href" target="_blank" @click.stop title="Meer informatie")
        i.fas.fa-info-circle
    .text.only-text(v-if="node.only" :class="{'vertical': !node.hasChildren || node.isLeaf || node.level >= 3}") {{node.only}}
  .pillar(v-show="isSelected || isActive" :style="{'background-color': node.color}" :class="{'is-active': isActive}")
  .children(v-if="node.hasChildren && !node.isLeaf")
    TableTreeHeader(v-for="c in node.children" :node="c" :papa="node" @select="handleSelect")
</template>

<script>
const Chroma = require('chroma-js')

export default {
  name: 'TableTreeHeader',
  props: ['node', 'papa'],
  data() {
    return {
      selected: false
    }
  },
  computed: {
    isSelected() {
      return this.selected || this.node.selected
    },
    isActive() {
      return this.node.active
    },
    currentColor() {
      return this.isSelected? new Chroma.Color(this.node.color).saturate(3).hex() : this.node.color
    },
    textColor() {
      try {
        const luminance = new Chroma.Color(this.currentColor).luminance()
        return luminance > 0.4 ? '#333' : 'white'
      } catch (e) {
        return '#333'
      }
    }
  },
  watch: {
    isSelected(newValue) {
      this.$emit('select', newValue ? this.node : null)
    }
  },
  methods: {
    handleSelect(obj) {
      this.$emit('select', obj) //emit up 
    },
    handleClick() {
      this.node.active = !this.node.active
      
    }
  },
  
}
</script>

<style scoped>
.cell {
  display: block;
  position: absolute;
  top: 0;
  text-align: center;
  height: 100%;
  cursor: pointer;
}
.cell .pillar {
  position: absolute;
  opacity: 0.25;
  top: 0; bottom: 0;
  width: 100%;
  z-index: 100;
}
.cell .pillar.is-active {
  border-left: 1px solid #333;
  border-right: 1px solid #333;
  opacity: 0.5;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.children {
  width: 100%;
  height: 100%;
  
  position: relative;
  margin-top: 4px;
}
.block {
  display: inline-block;
  width: 64px;
}
.node-title {
  width: 100%;
  z-index: 200;
  position: relative;
  border: 1px solid #666;
  border-radius: 4px;
  padding: 2px 0;
}
.node-title.only-partial {
  background-image: repeating-linear-gradient(
    45deg,
    transparent,
    transparent 6px,
    rgba(0, 0, 0, 0.13) 6px,
    rgba(0, 0, 0, 0.13) 12px
  );
}
.node-title .text {
  font-size: 12px;
  white-space: nowrap;
}
.node-title .text.vertical {
  display: inline-block;
  writing-mode: vertical-rl;
  text-orientation: sideways;
  transform: rotate(180deg);
  text-align: right;
  vertical-align: top;
}
.node-title .text.only-text {
  text-transform: uppercase;
}
.node-title.has-info-link {
  padding: 6px 0;
}
.info-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 6px;
  width: 20px;
  height: 20px;
  font-size: 12px;
  color: white;
  text-decoration: none;
  background: #22201e;
  border-radius: 50%;
  border: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  transition: background 0.2s ease, transform 0.15s ease;
  vertical-align: middle;
}
.info-btn:hover {
  background: #2e2b28;
  color: white;
  transform: scale(1.1);
}
</style>

